module.exports = __webpack_public_path__ + "static/presentation_image-bc182b7940ede1b4f6b6efb6139975ae.jpg";